import { createAsyncThunk } from '@reduxjs/toolkit';
import groupItemApi from '../../utils/api/groupItemApi';

export const fetchGroupItemById = createAsyncThunk('groupItems/GroupItemsByGroupId', async ({ params }) => {
  const groupItem = await groupItemApi.getGroupItems(params);
  return groupItem;
});

